import { Modal, ModalBody, ModalHeader } from "reactstrap";
import React, { useCallback } from "react";
import { LoadingSpinnerButton, PathwayButton } from "../../../_UI/Components/PathwayButtons";
import { FlexibleButtonModalFooter } from "../../../_UI/StyledComponents/PathwayModal";
import styled from "styled-components";

const ConfirmationModal = ({
    title,
    toggleConfirmationModal,
    buttonSubmit,
    isOpen,
    resetDropDown,
    loading,
    children,
    dataCy,
}) => {
    const submitFunction = useCallback(() => {
        (async () => {
            await buttonSubmit();
        })().then(() => {
            toggleConfirmationModal();
        });
    }, [buttonSubmit, toggleConfirmationModal]);

    function cancelProcess() {
        toggleConfirmationModal();
        if (resetDropDown) {
            resetDropDown();
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={cancelProcess} data-cy={dataCy ? dataCy + "-modal" : undefined}>
            <ModalHeader toggle={cancelProcess}>{title || "Confirmation"}</ModalHeader>
            <ModalContentBody>{children}</ModalContentBody>
            <FlexibleButtonModalFooter>
                <LoadingSpinnerButton
                    color="success"
                    loading={loading}
                    disabled={loading}
                    onClick={submitFunction}
                    data-cy={dataCy ? dataCy + "-submit-button" : undefined}
                >
                    Bestätigen
                </LoadingSpinnerButton>
                <PathwayButton
                    color="secondary"
                    onClick={cancelProcess}
                    data-cy={dataCy ? dataCy + "-cancel-button" : undefined}
                >
                    Abbrechen
                </PathwayButton>
            </FlexibleButtonModalFooter>
        </Modal>
    );
};

export default ConfirmationModal;

const ModalContentBody = styled(ModalBody)`
    & p {
        margin: 0;
    }
`;
